/**
 * アニメーション処理等で一定時間処理を待機させる
 *
 * @param second { Number } 待機させたい秒数（1s = 1）
 */
export default async function(second: number) {
  return new Promise(resolve => setTimeout(resolve, second * 1000))
}
